import React from "react";
import {useTranslation} from "react-i18next";
import {useProductListContext} from "../productListProvider/ProductListProvider";
import LoadingSpinner from "../../atoms/LoadingSpinner";

/**
 * The component showing some user action buttons like
 * - 'show more': loads the next batch of items
 * - 'filter': an anchor to the top of the page, using the `setShowFilters` callback
 * - 'go to super category': link to the primary linked super category
 * @constructor
 */
const ListViewMoreButton: React.FC = () => {
  const {t} = useTranslation();
  const {state, dispatch} = useProductListContext();

  const ListViewButtonContainer: React.FC<{children}> = ({children}) => {
    const noMatchingItems = !state.loading && state.total === 0;

    return (
      <div
        className={`product-list__more-btn column-8 ${
          state.showFilters && !noMatchingItems ? "column-shift-quarter" : "column-l-12"
        } bt-default`}
      >
        {children}
        {!noMatchingItems && (
          <p className="center my-3">
            {t("product.itemsViewed--quantity--total", {quantity: state.items.length, total: state.total})}
          </p>
        )}
      </div>
    );
  };

  // If no further items
  if (state.isLastPage) {
    // If category has primary super category, show link button
    const sectionNode = document.querySelector<HTMLElement>(".product-list-react, .product-list-react-redesign");
    const [url, title] = [sectionNode?.dataset.superCategoryUrl, sectionNode?.dataset.superCategoryTitle];

    if (url && title) {
      return (
        <ListViewButtonContainer>
          <a href={url} className="cta-button cta-green mt-6 mt-m-9">
            {t("product.seeAll--title", {title})}
          </a>
        </ListViewButtonContainer>
      );
    } else {
      // Show nothing
      return null;
    }
  }

  // More items to come
  return (
    <ListViewButtonContainer>
      <button
        className="cta-button cta-green mt-6 mt-m-9"
        onClick={() => {
          dispatch({
            type: "VIEW_MORE",
            payload: true,
          });
        }}
      >
        {state.loading ? <LoadingSpinner /> : <span>{t("general.showMore")}</span>}
      </button>
    </ListViewButtonContainer>
  );
};

export default ListViewMoreButton;
